import { InPersonSignerWithSigningStatus } from '../types';

export default function isSignableInPersonSigner(
  signer: InPersonSignerWithSigningStatus | undefined,
  currentSigningOrder: number
) {
  return (
    !!signer &&
    signer.signingOrder === currentSigningOrder &&
    !signer.hasSigned &&
    signer.signingExpiryDate.isValid
  );
}
